// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =========================================================
   DESIGN TOKENS
   Keep these in sync with the JS palettes in utils/theme.js
   ========================================================= */
:root {
  /* Exact font stack used across the ex_*.html marketing pages
     (About/Coverage/Contact/FAQ/etc.), so the app's own pages (Map,
     Reports, Profile, Users, Login) render in the same typeface. */
  --font-sans: 'Inter', ui-sans-serif, system-ui, -apple-system,
    BlinkMacSystemFont, 'Segoe UI', sans-serif;

  /* Brand palette — matches the EnergyPulseWorld marketing pages
     (SiteHeader/SiteFooter, Home/About/Contact/etc.), so the app and the
     public site read as one product. */
  --primary: #C8102E;
  --primary-hover: #9F0C24;
  --secondary: #FF5722;

  --background: #F5F7FA;
  --card-bg: #FFFFFF;

  --text-primary: #1A2233;
  --text-secondary: #55617A;
  --text-muted: #94A0B8;

  --border: #E2E8F0;
  --hover: #F1F5FB;
  --shadow: rgba(15, 23, 42, 0.08);
  --shadow-lg: rgba(15, 23, 42, 0.12);
  --surface-dark: #172033;

  --indicator-unselected: rgba(26, 34, 51, 0.18);
  --table-header-bg: #F3F5F9;
  --table-header-text: #1A2233;
  --chart-title-color: #1A2233;
  --selected-country-menu: rgba(200, 16, 46, 0.08);

  --tooltip-bg: #1A2233;
  --tooltip-text: #FFFFFF;

  /* switch colors */
  --switch-off-bg: #E1E6EE;
  --switch-on-bg: var(--primary);
  --switch-handle-off: #9FB0C9;
  --switch-handle-on: #FFFFFF;

  /* selection colors */
  --country-selected-bg: rgba(52, 195, 143, 0.15);
  --country-selected-bg-hover: rgba(52, 195, 143, 0.25);
  --country-selected-border: #34C38F;

  /* Compare mode intentionally keeps its own accent (rather than reusing
     --primary) so it stays visually distinct from "active/selected" red. */
  --country-compare-bg: rgba(47, 111, 237, 0.12);
  --country-compare-border: #2F6FED;

  --radius-sm: 8px;
  --radius-md: 12px;
  --radius-lg: 18px;

  --sidebar-width: 70px;
  --sidebar-width-expanded: 280px;
  --side-panel-width: 300px;
  --header-height: 77px;

  /* Bridge into Bootstrap 5 / CoreUI's own variables so their components
     (cards, buttons, badges, alerts, tabs...) pick up our brand color. */
  --bs-primary: var(--primary);
  --bs-primary-rgb: 200, 16, 46;

  --bs-link-color: var(--primary);
  --bs-link-color-rgb: 200, 16, 46;

  --bs-focus-ring-color: rgba(200, 16, 46, 0.25);

  --cui-primary: var(--primary);
  --cui-primary-rgb: 200, 16, 46;
}

[data-theme="dark"] {
  --primary: #FF7180;
  --primary-hover: #FF919B;
  --secondary: #FF9168;

  /* Cool neutral blue-gray */
  --background: #15191F;
  --card-bg: #1D2229;

  --text-primary: #E9EDF2;
  --text-secondary: #B5BEC9;
  --text-muted: #7E8996;

  --border: #303841;
  --hover: #262C34;

  --shadow: rgba(0, 0, 0, 0.30);
  --shadow-lg: rgba(0, 0, 0, 0.42);
  --surface-dark: #242A32;

  --indicator-unselected: rgba(181, 190, 201, 0.20);

  --table-header-bg: #242A32;
  --table-header-text: #E9EDF2;
  --chart-title-color: #E9EDF2;

  --selected-country-menu: rgba(255, 113, 128, 0.14);

  --tooltip-bg: #303841;
  --tooltip-text: #F2F5F8;

  --switch-off-bg: #303841;
  --switch-on-bg: var(--primary);
  --switch-handle-off: #697480;
  --switch-handle-on: #1D2229;

  --country-selected-bg: rgba(255, 113, 128, 0.14);
  --country-selected-bg-hover: rgba(255, 113, 128, 0.22);
  --country-selected-border: #FF7180;

  --country-compare-bg: rgba(61, 119, 228, 0.14);
  --country-compare-border: #6192E8;


  --bs-primary: var(--primary);
  --bs-primary-rgb: 255, 113, 128;

  --bs-link-color: var(--primary);
  --bs-link-color-rgb: 255, 113, 128;

  --bs-focus-ring-color: rgba(255, 113, 128, 0.25);

  --cui-primary: var(--primary);
  --cui-primary-rgb: 255, 113, 128;
}


/* =========================================================
   RESET / BASE
   ========================================================= */
* {
  box-sizing: border-box;
}

html, body, #root {
  height: 100%;
}

body {
  margin: 0;
  font-family: var(--font-sans);
  background: var(--background);
  color: var(--text-primary);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  transition: background-color 0.2s ease, color 0.2s ease;
}

h1, h2, h3, h4, h5, h6 {
  color: var(--text-primary);
}

a {
  color: var(--primary);
}

hr {
  border-color: var(--border);
  opacity: 1;
}

.page-title {
  font-size: 28px;
  font-weight: 700;
  letter-spacing: -0.02em;
  margin: 10px 0 20px 0;
  padding: 0 10px;
  color: var(--text-primary);
}

/* Scrollbars */
::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}
::-webkit-scrollbar-track {
  background: transparent;
}
::-webkit-scrollbar-thumb {
  background: var(--border);
  border-radius: 10px;
}
::-webkit-scrollbar-thumb:hover {
  background: var(--text-muted);
}

/* Visible keyboard focus everywhere */
a:focus-visible,
button:focus-visible,
input:focus-visible,
[tabindex]:focus-visible {
  outline: 2px solid var(--primary);
  outline-offset: 2px;
}

@media (prefers-reduced-motion: reduce) {
  *, *::before, *::after {
    animation-duration: 0.001ms !important;
    transition-duration: 0.001ms !important;
  }
}

/* =========================================================
   RESPONSIVE BREAKPOINTS (shared reference)
   <= 992px  : tablet / small laptop
   <= 768px  : tablet portrait / large phone
   <= 480px  : phone
   ========================================================= */
`, "",{"version":3,"sources":["webpack://./src/styles/global.css"],"names":[],"mappings":"AAAA;;;8DAG8D;AAC9D;EACE;;mEAEiE;EACjE;8CAC4C;;EAE5C;;uCAEqC;EACrC,kBAAkB;EAClB,wBAAwB;EACxB,oBAAoB;;EAEpB,qBAAqB;EACrB,kBAAkB;;EAElB,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;;EAErB,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,mCAAmC;EACnC,uBAAuB;;EAEvB,8CAA8C;EAC9C,0BAA0B;EAC1B,4BAA4B;EAC5B,4BAA4B;EAC5B,gDAAgD;;EAEhD,qBAAqB;EACrB,uBAAuB;;EAEvB,kBAAkB;EAClB,wBAAwB;EACxB,8BAA8B;EAC9B,4BAA4B;EAC5B,2BAA2B;;EAE3B,qBAAqB;EACrB,+CAA+C;EAC/C,qDAAqD;EACrD,kCAAkC;;EAElC;2EACyE;EACzE,8CAA8C;EAC9C,iCAAiC;;EAEjC,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;;EAEjB,qBAAqB;EACrB,+BAA+B;EAC/B,yBAAyB;EACzB,qBAAqB;;EAErB;yEACuE;EACvE,4BAA4B;EAC5B,6BAA6B;;EAE7B,+BAA+B;EAC/B,gCAAgC;;EAEhC,8CAA8C;;EAE9C,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,oBAAoB;;EAEpB,2BAA2B;EAC3B,qBAAqB;EACrB,kBAAkB;;EAElB,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;;EAErB,iBAAiB;EACjB,gBAAgB;;EAEhB,6BAA6B;EAC7B,gCAAgC;EAChC,uBAAuB;;EAEvB,iDAAiD;;EAEjD,0BAA0B;EAC1B,4BAA4B;EAC5B,4BAA4B;;EAE5B,kDAAkD;;EAElD,qBAAqB;EACrB,uBAAuB;;EAEvB,wBAAwB;EACxB,8BAA8B;EAC9B,4BAA4B;EAC5B,2BAA2B;;EAE3B,gDAAgD;EAChD,sDAAsD;EACtD,kCAAkC;;EAElC,8CAA8C;EAC9C,iCAAiC;;;EAGjC,4BAA4B;EAC5B,+BAA+B;;EAE/B,+BAA+B;EAC/B,kCAAkC;;EAElC,gDAAgD;;EAEhD,6BAA6B;EAC7B,gCAAgC;AAClC;;;AAGA;;8DAE8D;AAC9D;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,6BAA6B;EAC7B,0BAA0B;EAC1B,mCAAmC;EACnC,kCAAkC;EAClC,uDAAuD;AACzD;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;EACrB,eAAe;EACf,0BAA0B;AAC5B;;AAEA,eAAe;AACf;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,uBAAuB;AACzB;AACA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,6BAA6B;AAC/B;;AAEA,sCAAsC;AACtC;;;;EAIE,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE;IACE,sCAAsC;IACtC,uCAAuC;EACzC;AACF;;AAEA;;;;;8DAK8D","sourcesContent":["/* =========================================================\n   DESIGN TOKENS\n   Keep these in sync with the JS palettes in utils/theme.js\n   ========================================================= */\n:root {\n  /* Exact font stack used across the ex_*.html marketing pages\n     (About/Coverage/Contact/FAQ/etc.), so the app's own pages (Map,\n     Reports, Profile, Users, Login) render in the same typeface. */\n  --font-sans: 'Inter', ui-sans-serif, system-ui, -apple-system,\n    BlinkMacSystemFont, 'Segoe UI', sans-serif;\n\n  /* Brand palette — matches the EnergyPulseWorld marketing pages\n     (SiteHeader/SiteFooter, Home/About/Contact/etc.), so the app and the\n     public site read as one product. */\n  --primary: #C8102E;\n  --primary-hover: #9F0C24;\n  --secondary: #FF5722;\n\n  --background: #F5F7FA;\n  --card-bg: #FFFFFF;\n\n  --text-primary: #1A2233;\n  --text-secondary: #55617A;\n  --text-muted: #94A0B8;\n\n  --border: #E2E8F0;\n  --hover: #F1F5FB;\n  --shadow: rgba(15, 23, 42, 0.08);\n  --shadow-lg: rgba(15, 23, 42, 0.12);\n  --surface-dark: #172033;\n\n  --indicator-unselected: rgba(26, 34, 51, 0.18);\n  --table-header-bg: #F3F5F9;\n  --table-header-text: #1A2233;\n  --chart-title-color: #1A2233;\n  --selected-country-menu: rgba(200, 16, 46, 0.08);\n\n  --tooltip-bg: #1A2233;\n  --tooltip-text: #FFFFFF;\n\n  /* switch colors */\n  --switch-off-bg: #E1E6EE;\n  --switch-on-bg: var(--primary);\n  --switch-handle-off: #9FB0C9;\n  --switch-handle-on: #FFFFFF;\n\n  /* selection colors */\n  --country-selected-bg: rgba(52, 195, 143, 0.15);\n  --country-selected-bg-hover: rgba(52, 195, 143, 0.25);\n  --country-selected-border: #34C38F;\n\n  /* Compare mode intentionally keeps its own accent (rather than reusing\n     --primary) so it stays visually distinct from \"active/selected\" red. */\n  --country-compare-bg: rgba(47, 111, 237, 0.12);\n  --country-compare-border: #2F6FED;\n\n  --radius-sm: 8px;\n  --radius-md: 12px;\n  --radius-lg: 18px;\n\n  --sidebar-width: 70px;\n  --sidebar-width-expanded: 280px;\n  --side-panel-width: 300px;\n  --header-height: 77px;\n\n  /* Bridge into Bootstrap 5 / CoreUI's own variables so their components\n     (cards, buttons, badges, alerts, tabs...) pick up our brand color. */\n  --bs-primary: var(--primary);\n  --bs-primary-rgb: 200, 16, 46;\n\n  --bs-link-color: var(--primary);\n  --bs-link-color-rgb: 200, 16, 46;\n\n  --bs-focus-ring-color: rgba(200, 16, 46, 0.25);\n\n  --cui-primary: var(--primary);\n  --cui-primary-rgb: 200, 16, 46;\n}\n\n[data-theme=\"dark\"] {\n  --primary: #FF7180;\n  --primary-hover: #FF919B;\n  --secondary: #FF9168;\n\n  /* Cool neutral blue-gray */\n  --background: #15191F;\n  --card-bg: #1D2229;\n\n  --text-primary: #E9EDF2;\n  --text-secondary: #B5BEC9;\n  --text-muted: #7E8996;\n\n  --border: #303841;\n  --hover: #262C34;\n\n  --shadow: rgba(0, 0, 0, 0.30);\n  --shadow-lg: rgba(0, 0, 0, 0.42);\n  --surface-dark: #242A32;\n\n  --indicator-unselected: rgba(181, 190, 201, 0.20);\n\n  --table-header-bg: #242A32;\n  --table-header-text: #E9EDF2;\n  --chart-title-color: #E9EDF2;\n\n  --selected-country-menu: rgba(255, 113, 128, 0.14);\n\n  --tooltip-bg: #303841;\n  --tooltip-text: #F2F5F8;\n\n  --switch-off-bg: #303841;\n  --switch-on-bg: var(--primary);\n  --switch-handle-off: #697480;\n  --switch-handle-on: #1D2229;\n\n  --country-selected-bg: rgba(255, 113, 128, 0.14);\n  --country-selected-bg-hover: rgba(255, 113, 128, 0.22);\n  --country-selected-border: #FF7180;\n\n  --country-compare-bg: rgba(61, 119, 228, 0.14);\n  --country-compare-border: #6192E8;\n\n\n  --bs-primary: var(--primary);\n  --bs-primary-rgb: 255, 113, 128;\n\n  --bs-link-color: var(--primary);\n  --bs-link-color-rgb: 255, 113, 128;\n\n  --bs-focus-ring-color: rgba(255, 113, 128, 0.25);\n\n  --cui-primary: var(--primary);\n  --cui-primary-rgb: 255, 113, 128;\n}\n\n\n/* =========================================================\n   RESET / BASE\n   ========================================================= */\n* {\n  box-sizing: border-box;\n}\n\nhtml, body, #root {\n  height: 100%;\n}\n\nbody {\n  margin: 0;\n  font-family: var(--font-sans);\n  background: var(--background);\n  color: var(--text-primary);\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  transition: background-color 0.2s ease, color 0.2s ease;\n}\n\nh1, h2, h3, h4, h5, h6 {\n  color: var(--text-primary);\n}\n\na {\n  color: var(--primary);\n}\n\nhr {\n  border-color: var(--border);\n  opacity: 1;\n}\n\n.page-title {\n  font-size: 28px;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  margin: 10px 0 20px 0;\n  padding: 0 10px;\n  color: var(--text-primary);\n}\n\n/* Scrollbars */\n::-webkit-scrollbar {\n  width: 10px;\n  height: 10px;\n}\n::-webkit-scrollbar-track {\n  background: transparent;\n}\n::-webkit-scrollbar-thumb {\n  background: var(--border);\n  border-radius: 10px;\n}\n::-webkit-scrollbar-thumb:hover {\n  background: var(--text-muted);\n}\n\n/* Visible keyboard focus everywhere */\na:focus-visible,\nbutton:focus-visible,\ninput:focus-visible,\n[tabindex]:focus-visible {\n  outline: 2px solid var(--primary);\n  outline-offset: 2px;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  *, *::before, *::after {\n    animation-duration: 0.001ms !important;\n    transition-duration: 0.001ms !important;\n  }\n}\n\n/* =========================================================\n   RESPONSIVE BREAKPOINTS (shared reference)\n   <= 992px  : tablet / small laptop\n   <= 768px  : tablet portrait / large phone\n   <= 480px  : phone\n   ========================================================= */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
